import altonTheme from 'typography-theme-alton'

import { TypographyOptions } from './types'

export const typography: TypographyOptions = {
  ...altonTheme,
  baseFontSize: '16px',
}
